/* tslint:disable */
/* eslint-disable */
export enum ExcelDocumentTypeEnum {
  Partneraftaler = 'Partneraftaler',
  Serviceaftaler = 'Serviceaftaler',
  Serviceordrer = 'Serviceordrer',
  PartnerPostcode = 'PartnerPostcode'
}
